<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

definePageMeta({
    middleware: ['redirect'],
    parking: true, // This marks the page as part of parking world,
    auth: true, // This marks the page as auth-protected
    ignoreOnBoarding: true
})

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Get center details
const { data: centerDetails, suspense: centerDetailSuspense } = useFetchCenterDetails(centerRoute.value)

onServerPrefetch(async () => {
    await centerDetailSuspense()
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Seo
useSeoMeta({
    title: () => `${staticKeys.value?.parkingfirstpage_headline} | ${centerDetails.value?.centerName}`
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: false }">
        <CenterLogoHeader />
        <ParkingPaymentList />
    </PageMainContainer>
</template>
